import { useController } from 'react-hook-form';
import Input from '../../../ui/Input';
import GetCoordinates from './GetCoordinates';
import IsSkippable from './IsSkippable';
import { BountiesContext } from '../../../contexts/BountiesContext';
import { useContext, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import Heading from '../../../ui/Heading';

mapboxgl.accessToken =
    'pk.eyJ1IjoiZmFpc2FsZHJvcGNoYWluIiwiYSI6ImNsdXJnOWF2czA3NmYyam4xZWkzbmltaHAifQ.IK0wrkOv-H-C57rLCcMBMA';
const VisitLocation = ({ register, index, errors, control, setValue, microtaskEditDetail, currentMt }) => {
    const { isEdit } = useContext(BountiesContext);

    useEffect(() => {
        // Run this logic only once when the component is mounted
        if (isEdit) {
            setValue(`microtasks.${index}.goToLocation_coordinate`, microtaskEditDetail?.gotoLocation_coordinate);
        }
    }, [isEdit]);

    return (
        <div>
            <div className="mb-2">
                <Heading type="microtaskTitle" className="capitalize text-textPrimary mb-1">
                    Title <sup className="text-lg relative top-[1px]">*</sup>
                </Heading>
                <Input
                    {...register(`microtasks.${index}.goToLocation_Title`, {
                        required: 'Please enter a title',
                    })}
                    {...(isEdit && { defaultValue: microtaskEditDetail?.gotoLocation_Title || '' })}
                    error={errors?.microtasks && errors?.microtasks[index]?.goToLocation_Title?.message}
                    placeholder={'Describe the microtask objective in 1 line'}
                    className={'w-[100%]'}
                />
            </div>

            <div className="mb-2">
                <Heading type="microtaskTitle" className="capitalize text-textPrimary mb-1">
                    Task Description <sup className="text-lg relative top-[1px]">*</sup>
                </Heading>
                <Input
                    {...register(`microtasks.${index}.goToLocation_Description`, {
                        required: 'Please enter a description',
                    })}
                    {...(isEdit && { defaultValue: microtaskEditDetail?.gotoLocation_Description || '' })}
                    error={errors?.microtasks && errors?.microtasks[index]?.goToLocation_Description?.message}
                    placeholder={'Describe the task'}
                    className={'w-[100%]'}
                />
            </div>

            <GetCoordinates
                control={control}
                errors={errors}
                microIndex={index}
                setValue={setValue}
                editCoords={
                    isEdit
                        ? microtaskEditDetail?.gotoLocation_coordinate?.split(',')?.reverse()
                        : Boolean(currentMt?.goToLocation_coordinate)
                        ? currentMt?.goToLocation_coordinate?.split(',')?.reverse()
                        : [77.5115746, 12.972048]
                }
                isEdit={isEdit}
            />
            {/* <div className="flex gap-9 my-2 items-center ">
                <IsSkippable
                    selectedOption={skippableField.value}
                    onSelectOption={(value) => {
                        skippableField.onChange(value);
                    }}
                    options={['Yes', 'No']}
                />
            </div> */}
        </div>
    );
};

export default VisitLocation;
